import { useEffect, useState } from 'react'

// Tracks the Tailwind `lg` breakpoint (1024px) so a component can pick between
// a mobile-only render tree and a desktop-only render tree, never mounting
// both at once. That matters for panes that fetch their own data on mount:
// mounting two copies (one hidden via CSS) would double every request.
export function useIsDesktop(): boolean {
  const query = '(min-width: 1024px)'
  const [isDesktop, setIsDesktop] = useState<boolean>(() =>
    typeof window !== 'undefined' ? window.matchMedia(query).matches : true,
  )

  useEffect(() => {
    const mq = window.matchMedia(query)
    const handler = (e: MediaQueryListEvent) => setIsDesktop(e.matches)
    mq.addEventListener('change', handler)
    return () => mq.removeEventListener('change', handler)
  }, [])

  return isDesktop
}
